export default "__VITE_ASSET__B6i5Pv_g__"